<div class="content">
    <div class="row items-push">
      <div class="col-sm-12 text-left">
        <ol class="breadcrumb push-10-t">
          <li><a href="">Inicio</a></li>
          <li>
            <a
              class="link-effect"
              [routerLink]="['/listanegra']"
              >Lista Negra</a
            >
          </li>
          <li><span class="link-effect">Registrar</span></li>
        </ol>
      </div>
    </div>
  </div>
  
  <div class="content">
    <div class="block">
      <div class="block-header">
        <h3 class="block-title">Registrar Lista Negra</h3>
      </div>
      <div class="block-content">
        <div class="form-horizontal">
          <form
            #modelForm="ngForm"
            (ngSubmit)="onSubmit(modelForm)"
            appIdentityRevealed
          >
            <div class="form-group">
              <label class="col-md-1 control-label">Nombres (*):</label>
              <div class="col-md-2">
                <mat-form-field appearance="outline" hideRequiredMarker>
                  <mat-label>Nombres</mat-label>
                  <input
                    matInput
                    type="text"
                    [(ngModel)]="model.nombres"
                    name="nombre"
                    maxlength="40"
                    required
                  />
                </mat-form-field>
              </div>
            </div>
            <div class="form-group">
              <label class="col-md-1 control-label">Apellido Paterno (*):</label>
              <div class="col-md-2">
                <mat-form-field appearance="outline" hideRequiredMarker>
                  <mat-label>Apellido Paterno</mat-label>
                  <input
                    matInput
                    type="text"
                    [(ngModel)]="model.apellidoPaterno"
                    name="apellidoPaterno"
                    maxlength="40"
                    required
                  />
                </mat-form-field>
              </div>
            </div>
            <div class="form-group">
              <label class="col-md-1 control-label">Apellido Materno (*):</label>
              <div class="col-md-2">
                <mat-form-field appearance="outline" hideRequiredMarker>
                  <mat-label>Apellido Materno</mat-label>
                  <input
                    matInput
                    type="text"
                    [(ngModel)]="model.apellidoMaterno"
                    name="apellidoMaterno"
                    maxlength="40"
                    required
                  />
                </mat-form-field>
              </div>
            </div>
            <div class="form-group">
                <label class="col-md-1 control-label">Tipo de Documento de Identidad (*):</label>
                    <div class="col-md-2">
                        <mat-form-field appearance="outline" hideRequiredMarker>
                        <mat-label>Seleccione</mat-label>
                        <mat-select
                            matSelect
                            [(ngModel)]="model.idTipoDocumentoIdentidad"
                            name="idTipoDocumentoIdentidad"
                            required
                        >
                            <mat-option
                            *ngFor="let item of listaTiposDocumento; index as i"
                            [value]="item.idParametroDetalle"
                            >{{ item.nombre }}</mat-option
                            >
                        </mat-select>
                        </mat-form-field>
                    </div>
            </div>
            <div class="form-group">
              <label class="col-md-1 control-label">Nro Documento Identidad (*):</label>
              <div class="col-md-2">
                <mat-form-field appearance="outline" hideRequiredMarker>
                  <mat-label>Nro Documento Identidad</mat-label>
                  <input
                    matInput
                    type="text"
                    [(ngModel)]="model.nroDocumentoIdentidad"
                    name="nroDocumentoIdentidad"
                    maxlength="15"
                    required
                  />
                </mat-form-field>
              </div>
            </div>
            <div class="form-group">
              <label class="col-md-1 control-label">Compañía (*):</label>
              <div class="col-md-4">
                <mat-form-field appearance="outline">
                  <mat-label> Compañía </mat-label>
                  <mat-select matSelect [(ngModel)]="model.idCompania" 
                  id="idCompania"
                  name="idCompania"
                  required>
                    <mat-option *ngFor="let company of listaCompanias" [value]="company.idCompania">
                      {{ company.nombre }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </div>
            <div class="form-group">
              <label class="col-md-1 control-label">Motivo (*):</label>
              <div class="col-md-4">
                <mat-form-field appearance="outline" hideRequiredMarker>
                  <mat-label>Motivo</mat-label>
                  <textarea
                    matInput
                    placeholder="Motivo"
                    [(ngModel)]="model.motivoRegistro"
                    rows="5"
                    id="motivoRegistro"
                    name="motivoRegistro"
                    #motivo="ngModel" [maxlength]="2000"
                    required
                ></textarea> 
                </mat-form-field>
              </div>
            </div>
            <div class="form-group">
              <div class="col-sm-12">
                <button
                  type="submit"
                  class="btn btn-naranja"
                  [disabled]="modelForm.invalid"
                  mat-raised-button
                >
                  Guardar
                </button>
                <a
                  class="btn btn-naranja2"
                  mat-raised-button
                  [routerLink]="['/listanegra']"
                  >Cancelar</a
                >
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  